package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

// Conteneur principal
val PersonalFormMainColumnStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(16.px)
    }
    Breakpoint.MD {
        Modifier.gap(24.px)
    }
}

// Sub-column
val PersonalFormGroupColumnStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(16.px)
    }
    Breakpoint.MD {
        Modifier.gap(24.px)
    }
}

// Rangée réactive : Colonne en mobile, Ligne en desktop
val PersonalFormRowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flexDirection(FlexDirection.Column)
            .gap(16.px)
    }
    Breakpoint.MD {
        Modifier
            .flexDirection(FlexDirection.Row)
            .gap(20.px)
    }
}

// Champ à demi-largeur : 100% sur mobile, flexible (50%) sur Desktop
val PersonalFormHalfWidthStyle = CssStyle {
    base {
        Modifier.fillMaxWidth()
    }
    Breakpoint.MD {
        Modifier
            .fillMaxWidth()
            .flexGrow(1)
            .flexShrink(1)
            .flexBasis(0.px) // Prend 50% de l'espace disponible dans le Row
    }
}

// Champ pleine largeur
val PersonalFormFullWidthStyle = CssStyle {
    base {
        Modifier.fillMaxWidth()
    }
}

